import * as React from "react";
import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";

interface OwnProps {
    customerId: string;
    id: any;
    path: string;
    delete: (customerId: string, id: string, basePath: string) => void;
}

export default class DeleteButton extends React.Component<OwnProps> {
    public render() {
        return (
            <ConfirmedButton
                icon="delete"
                content="Delete"
                floated="left"
                className="warning"
                onClick={() => this.props.delete(this.props.customerId, this.props.id, this.props.path)}
                promptText="Are you sure you want to delete this organisation structure level?"
                headingText="Delete Organisation Structure Level"
            />);
    }
}
